import { render, staticRenderFns } from "./veStuGraduationXuhaoShow.vue?vue&type=template&id=cd9f2064&scoped=true"
import script from "./veStuGraduationXuhaoShow.vue?vue&type=script&lang=js"
export * from "./veStuGraduationXuhaoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9f2064",
  null
  
)

export default component.exports